import { render, staticRenderFns } from "./StorageSpaceMediaForm.vue?vue&type=template&id=4bd1c91f&"
import script from "./StorageSpaceMediaForm.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceMediaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports